import React, { Component } from 'react';
import styles from './palette.less.js';
import { convert } from 'chromatism2';
import { fromEvent } from 'rxjs';
import { throttleTime, take } from 'rxjs/operators';
import { limit } from '../../../../../utils/math-utils.js';

class Hue extends Component {
    constructor() {
        super(...arguments);
        this.back = React.createRef();
        this.mousemove = null;
        this.draging = false;
        this.handleMouseDown = () => {
            this.rect = this.back.current.getBoundingClientRect();
            if (this.mousemove) {
                this.mousemove.unsubscribe();
            }
            this.mousemove = fromEvent(window, 'mousemove')
                .pipe(throttleTime(10))
                .subscribe(this.handleMouseMove);
            fromEvent(window, 'mouseup')
                .pipe(take(1))
                .subscribe(this.handleMouseUp);
        };
        this.handleMouseMove = (e) => {
            this.draging = true;
            this.props.onColorChange(this.calculate(e));
        };
        this.handleMouseUp = (e) => {
            if (this.draging) {
                this.draging = false;
            }
            if (this.mousemove) {
                this.mousemove.unsubscribe();
                this.mousemove = null;
            }
            this.props.onColorSelect(this.calculate(e));
        };
    }
    calculate(e) {
        const { hsv } = this.props.color;
        const hue = (e.clientX - this.rect.left) / this.rect.width * 360;
        const colour = convert({ h: limit(hue, 0, 360), s: limit(hsv.s, 1, 100), v: hsv.v });
        return colour;
    }
    render() {
        const pos = this.props.color.hsv.h / 3.6;
        return (React.createElement("div", { className: styles.hue, ref: this.back },
            React.createElement("div", { className: styles.slider, onMouseDown: this.handleMouseDown }),
            React.createElement("div", { className: styles.slide, style: { left: `${pos}%` } })));
    }
}

export { Hue };
//# sourceMappingURL=hue.js.map
